import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, MapPin } from 'lucide-react';
import { siteConfig } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Heart size={22} fill="#D3FF62" color="#D3FF62" />
              {siteConfig.name}
            </div>
            <p className="footer-description">
              {siteConfig.description}
            </p>
            <div style={{ marginTop: '24px', fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                <Mail size={16} />
                <span>{siteConfig.email}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MapPin size={16} />
                <span>{siteConfig.location}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/what-we-do">What We Do</Link></li>
              <li><Link to="/help-a-horse">Help a Horse</Link></li>
              <li><Link to="/education">Education</Link></li>
              <li><Link to="/news">News & Updates</Link></li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="footer-heading">Get Involved</h4>
            <ul className="footer-links">
              <li><Link to="/get-involved/donate">Donate</Link></li>
              <li><Link to="/get-involved/volunteer">Volunteer</Link></li>
              <li><Link to="/get-involved/fundraise">Fundraise</Link></li>
              <li><Link to="/livery-scheme">Livery Scheme</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/admin/login" style={{ opacity: 0.6, fontSize: '13px' }}>Volunteer Login</Link></li>
            </ul>
          </div>

          {/* Our Work */}
          <div>
            <h4 className="footer-heading">Our Work</h4>
            <ul className="footer-links">
              <li><Link to="/what-we-do/sanctuary">Sanctuary Care</Link></li>
              <li><Link to="/what-we-do/rehabilitation">Rehabilitation</Link></li>
              <li><Link to="/what-we-do/rehoming">Rehoming Programme</Link></li>
              <li><Link to="/what-we-do/lifelong-sanctuary">Lifelong Sanctuary</Link></li>
              <li><Link to="/livery-scheme/report">Report Concern</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
              <img 
                src="/scvo-logo.png" 
                alt="SCVO Member - Scottish Council for Voluntary Organisations" 
                style={{ 
                  height: '60px',
                  width: 'auto',
                  objectFit: 'contain'
                }}
              />
            </div>
            <p style={{ marginBottom: '4px' }}>
              The Grazing Trust is a Nonprofit Association working to achieve full Scottish Charitable Incorporated Organisation (SCIO) status.
            </p>
            <p>
              © {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
            </p>
          </div>
          <div className="footer-legal-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/safeguarding">Safeguarding</Link>
            <Link to="/terms">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
